import './sendOtp.scss';
import React from 'react';
import { Translate, translate, Storage } from 'react-jhipster';
import { connect } from 'react-redux';
import { Redirect, RouteComponentProps } from 'react-router-dom';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import { Row, Col, Button, Alert } from 'reactstrap';
import { IRootState } from 'app/shared/reducers';
import { storeInfoNewPhone, reSendOtp } from './sendOtp.reducer';
import { KEY_LOGIN, SUCCESS } from 'app/config/constants';
import ModalInputCaptcha from './modal-resend-otp';
import { generateCaptcha } from '../account/password-reset/password-reset.reducer';
import { colors } from 'app/config/color';

export interface IResendOptionProps extends StateProps, DispatchProps, RouteComponentProps<{}> {}

export interface IResendOptionState {
  type: string;
  typed: boolean;
  send: boolean;
  displayModalCaptcha: boolean;
  alertMess: string;
  isOpenAlert: boolean;
  color: string;
}

export class ResendOption extends React.Component<IResendOptionProps, IResendOptionState> {
  state: IResendOptionState = {
    type: 'email',
    typed: false,
    send: false,
    displayModalCaptcha: false,
    alertMess: '',
    isOpenAlert: false,
    color: 'info'
  };

  componentDidMount() {
    const { type } = this.props.location.state;
    if (type && type === 'mobile') {
      this.setState({
        typed: true
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    // if (this.props.responseSendOtp !== nextProps.responseReSend) {
    //     const { responseReSend } = nextProps;
    //     if (responseReSend && responseReSend.status === SUCCESS) {
    //         this.setState({ send: true });
    //     } else if (responseReSend && responseReSend.status) {
    //         // Xử lý lỗi nếu có
    //         //   this.setState({
    //         //     visible: true,
    //         //     color: 'danger',
    //         //     message: responseReSend.message
    //         //   });
    //     }
    // }
    if (this.props.responseReSend !== nextProps.responseReSend) {
      const { responseReSend } = nextProps;
      if (responseReSend && responseReSend.status === SUCCESS) {
        this.setState({
          color: 'success',
          displayModalCaptcha: false
        });
      } else if (responseReSend && responseReSend.status) {
        this.props.generateCaptcha();
        this.setState({
          // visible: true,
          color: 'danger',
          // message: responseReSend.message,
          alertMess: responseReSend.message,
          isOpenAlert: true
        });
      }
      this.props.generateCaptcha();
    }
  }

  // handleReSendOtp = () => {
  //     this.setState({
  //         displayModalCaptcha: true
  //     });
  // };

  invokeAgree = formData => {
    const { id, type } = this.props.location.state;
    this.props.reSendOtp(id, type, formData.code.trim());
    this.setState({
      send: true
    });
  };

  invokeCancel = () => {
    this.setState({
      displayModalCaptcha: false
    });
  };

  invokeDimiss = () => {
    this.setState({
      isOpenAlert: false
    });
  };

  render() {
    let { mobile, id, email, type, fullname } = this.props.location.state;
    // let mobile = '0123456789';
    // let id = '1';
    // let email = 'testemail@gmail.com';
    // let name = 'Nguyen Van A'
    if (this.state.send) {
      return (
        <Redirect
          push
          to={{
            pathname: '/sendOtp',
            state: {
              mobile: mobile,
              id: id,
              email: email,
              type: this.state.type,
              fullName: fullname
            }
          }}
        />
      );
    }

    if (mobile) {
      mobile = mobile.startsWith('84') ? mobile.replace('84', '0') : mobile;
      mobile = mobile.slice(0, 3) + 'xxxx' + mobile.slice(7, mobile.length);

      email = email;
      const atIndex = email.indexOf('@');
      if (atIndex > 4) {
        const maskedPart = email.substring(0, 4) + '****';
        const domainPart = email.substring(atIndex);
        email = maskedPart + domainPart;
      }
    }

    return (
      <div>
        <ModalInputCaptcha
          showModalCaptcha={this.state.displayModalCaptcha}
          invokeAgree={this.invokeAgree}
          invokeCancel={this.invokeCancel}
          errMessage={this.state.alertMess}
          isOpenAlert={this.state.isOpenAlert}
          dismissAlert={this.invokeDimiss}
        />
        <div className="box-reotp">
          <div style={{ position: 'absolute', top: '10px', right: '10px' }}>
            <Button onClick={() => this.setState({ send: true })} close />
          </div>
          <Row>
            <Col className="justify-content-center">
              <h2 className="text-center">Chọn phương thức xác thực</h2>
              <p className="text-center">Chào mừng bạn đến với Ngân hàng Chính sách xã hội</p>
              <p className="text-center" style={{ color: 'black' }}>
                Tài khoản: <span>{fullname ? fullname : ''}</span>{' '}
              </p>
              <p className="text-center" style={{ marginTop: '50px' }}>
                Chọn phương thức xác thực
              </p>
              <AvForm id="resend-otp-form">
                <div
                  style={{
                    width: '414px',
                    height: '50px',
                    margin: '10px auto',
                    background: this.state.typed === true ? '#4D9235' : '#70AE5A'
                  }}
                  className="d-flex align-items-center"
                  onClick={() => {
                    this.setState({ type: 'email', typed: false, displayModalCaptcha: true });
                  }}
                >
                  <div>
                    <img src={require('app/images/email.png')} style={{ width: '24.37px', marginLeft: '16.41px' }} alt="" />
                    <span className="type-sotp">Xác thực Email: {email ? email : ''}</span>
                  </div>
                </div>
                {mobile && mobile ? (
                  <div
                    style={{
                      width: '414px',
                      height: '50px',
                      margin: '10px auto',
                      background: this.state.typed === true ? '#70AE5A' : '#4D9235'
                    }}
                    className="d-flex align-items-center"
                    onClick={() => {
                      this.setState({ type: 'mobile', typed: true, displayModalCaptcha: true });
                    }}
                  >
                    <div>
                      <img src={require('app/images/mobile.png')} style={{ width: '15.17px', marginLeft: '21px' }} alt="" />
                      <span className="type-sotp">Xác thực điện thoại di động: {mobile ? mobile : ''}</span>
                    </div>
                  </div>
                ) : null}
              </AvForm>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (storeState: IRootState) => ({
  responseReSend: storeState.sendotp.response
});

const mapDispatchToProps = { storeInfoNewPhone, reSendOtp, generateCaptcha };

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ResendOption);
